"use strict";import{tag as l}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const Dash300Icon=({width:t=24,height:e=24,hidden:a=!1,title:r="Dash300"}={})=>l`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    aria-hidden=${a?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${r}"
    width="${t}"
    height="${e}"
  >
    <path d="M10.61 7.085H1.39a1.085 1.085 0 0 1 0-2.17h9.22a1.085 1.085 0 0 1 0 2.17" />
  </svg>`;
//# sourceMappingURL=Dash300.js.map
